"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import fetch from "./fetch";
import { Flash } from "../components/flash";
import { OktaAuth } from "@okta/okta-auth-js";
import Reskin from "../helpers/reskin";
const paths = {
  login: "/users/sign_in.json",
  logout: "/users/sign_out.json",
  register: "/users.json",
  requestPasswordReset: "/users/password.json",
  resetPassword: "/users/password.json",
  switchUser: "/users/switch.json",
  getOktaStatus: "/users/okta_status.json"
};
const methods = {
  login: "POST",
  logout: "DELETE",
  register: "POST",
  requestPasswordReset: "POST",
  resetPassword: "PUT",
  switchUser: "POST",
  getOktaStatus: "GET"
};
const hubtranUserKey = "hubtran-user";
function httpConfig(action, data = null) {
  const config = {
    method: methods[action].toLowerCase(),
    url: paths[action]
  };
  if (data) {
    config.data = data;
  }
  return config;
}
function constant(arg) {
  return function() {
    return arg;
  };
}
class AuthService {
  constructor() {
    __publicField(this, "_currentUser", null);
    __publicField(this, "onChange", () => {
    });
  }
  parse(response) {
    return response;
  }
  save(user) {
    this._currentUser = user;
    if (user) {
      sessionStorage.setItem(hubtranUserKey, JSON.stringify(user));
      localStorage.setItem(hubtranUserKey, JSON.stringify(user));
    } else {
      sessionStorage.removeItem(hubtranUserKey);
      localStorage.removeItem(hubtranUserKey);
    }
    return user;
  }
  reset() {
    this.save(null);
  }
  register(cr) {
    const creds = cr || {};
    const config = httpConfig("register", { user: creds });
    return fetch(config.url, config).then(this.parse).then(this.save.bind(this));
  }
  getCurrentUser() {
    return this._currentUser || sessionStorage.getItem(hubtranUserKey) && this.userFromSession();
  }
  userFromSession() {
    const user = JSON.parse(sessionStorage.getItem(hubtranUserKey));
    this.save(user);
    return user;
  }
  currentUser() {
    if (this.isAuthenticated()) {
      this.onChange(true);
      return Promise.resolve(this.getCurrentUser());
    }
    return this.login();
  }
  login(credsOrToken) {
    const isToken = typeof credsOrToken === "string";
    const creds = isToken ? {} : credsOrToken;
    const token = isToken ? credsOrToken : null;
    const config = httpConfig("login", { user: creds, token });
    return fetch(config.url, config).then(this.parse).then(this.save.bind(this)).then((user) => {
      this.onChange(true);
      return user;
    }).catch((error) => {
      this.onChange(false);
      throw error;
    });
  }
  logout() {
    Reskin.clearToggleUser();
    const oldUser = constant(this._currentUser);
    const config = httpConfig("logout");
    return fetch(config.url, config).then(() => this.reset()).then(() => this.onChange(false)).then(() => this.logoutOkta()).then(oldUser);
  }
  logoutOkta() {
    const user = this.getCurrentUser();
    if (!user || !user["okta_enabled?"]) {
      return;
    }
    const oktaConfig = JSON.parse(window.oktaConfig);
    const authClient = new OktaAuth({
      issuer: oktaConfig.issuer,
      clientId: oktaConfig.clientId,
      redirectUri: oktaConfig.callbackUri
    });
    authClient.signOut({
      postLogoutRedirectUri: oktaConfig.logoutRedirectUri
    });
  }
  getOktaStatus(email) {
    const config = httpConfig("getOktaStatus", { email });
    return fetch(config.url, config);
  }
  switchUser(userId) {
    const config = httpConfig("switchUser", { id: userId });
    return fetch(config.url, config).then(this.save.bind(this)).then(() => window.location.href = "/app");
  }
  requestPasswordReset(creds) {
    const config = httpConfig("requestPasswordReset", { user: creds });
    return fetch(config.url, config);
  }
  resetPassword(creds) {
    const config = httpConfig("resetPassword", { user: creds });
    return fetch(config.url, config);
  }
  isAuthenticated() {
    return !!this.getCurrentUser();
  }
  syncUserWithUpdatesFromOtherTabs(newUser) {
    if (newUser) {
      const oldUser = this._currentUser;
      if (!oldUser || newUser.id != oldUser.id) {
        Flash.warning(
          "You have changed accounts from another tab or window. The page will refresh shortly."
        );
        this.save(newUser);
        window.location.href = "/app";
      } else if (oldUser != null && newUser.terms_agreed_to_at != oldUser.terms_agreed_to_at) {
        console.log("INFO: terms_agreed_to_at changed: refreshing currentUser");
        this.save(newUser);
      }
    } else {
      Flash.warning("You have been logged out from another tab or window.");
      this.reset();
      window.location.href = "/app/login";
    }
  }
  v3ReskinAccountSettings() {
    var _a, _b;
    const settings = (_b = (_a = this._currentUser) == null ? void 0 : _a.account) == null ? void 0 : _b.settings;
    return {
      topLevel: !!(settings == null ? void 0 : settings.audit_v3_reskin_enabled_top_level),
      settings: !!(settings == null ? void 0 : settings.audit_v3_reskin_enabled_settings),
      queues: !!(settings == null ? void 0 : settings.audit_v3_reskin_enabled_queues),
      indexAudit: !!(settings == null ? void 0 : settings.audit_v3_react_style_overrides_enabled),
      everything: !!(settings == null ? void 0 : settings.audit_v3_reskin_enabled_everything)
    };
  }
}
const Auth = new AuthService();
window.addEventListener("storage", (e) => {
  if (window.location.pathname.startsWith("/admin")) {
    return;
  }
  if (e.key == hubtranUserKey && e.storageArea == localStorage) {
    Auth.syncUserWithUpdatesFromOtherTabs(
      JSON.parse(localStorage.getItem(hubtranUserKey))
    );
  }
});
window.Auth = Auth;
export default Auth;
